const inputFields = [
  {
    name: "name",
    type: "text",
    label: "Name*",
    placeholder: "Name",
  },
  {
    name: "email",
    type: "email",
    label: "Email*",
    placeholder: "Email",
  },
  {
    name: "countryCode",
    type: "text",
    label: "Country Code*",
    placeholder: "+91",
  },
  {
    name: "mobileNumber",
    type: "text",
    label: "Mobile Number*",
    placeholder: "Mobile Number",
  },
  {
    name: "profilePic",
    type: "image",
    label: "Profile Picture",
    placeholder: "",
    allowType: ["image/jpeg", "image/png", "image/jpg"],
    allowTypeError: "JPEG, PNG, JPG",
  },
];

export default inputFields;